<div class="image-preview-dialog" (click)="closeDialog()">
  <div class="dialog-actions" (click)="$event.stopPropagation()">
    <button
      nbButton
      status="primary"
      size="small"
      (click)="downloadImage()"
      [disabled]="!imageUrl || imageError"
      class="action-button"
    >
      <fa-icon icon="arrow-down-to-line"></fa-icon>
    </button>
    <button 
      nbButton 
      status="basic" 
      size="small" 
      (click)="closeDialog()"
      class="action-button"
    >
      <fa-icon icon="times"></fa-icon>
    </button>
  </div>
  
  <div class="dialog-content" (click)="$event.stopPropagation()">
    @if (imageError) {
    <div class="image-error-placeholder">
      <fa-icon icon="image" class="placeholder-icon"></fa-icon>
    </div>
    } @else {
    <img
      [src]="imageUrl"
      [alt]="imageAlt"
      class="preview-image"
      (error)="onImageError($event)"
      (click)="closeDialog()"
    />
    }
  </div>
</div>
